module.exports = __webpack_public_path__ + "static/images/85769352fce01cc27aad47e16369493e.svg";